export default "__VITE_ASSET__DBToeKId__"